export default __webpack_public_path__ + "img/error.ad18406c.svg";